import { render } from "./RegisterationSection.vue?vue&type=template&id=4816cd72&scoped=true"
import script from "./RegisterationSection.vue?vue&type=script&lang=js"
export * from "./RegisterationSection.vue?vue&type=script&lang=js"

import "./RegisterationSection.vue?vue&type=style&index=0&id=4816cd72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4816cd72"]])

export default __exports__